// @ts-nocheck
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import * as Yup from "yup";
import { isString, useFormik } from "formik";
import MainContainer from "../../layout/MainContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { ChangeEvent, useEffect, useState } from "react";
import {
  useLazyGetCategoriesQuery,
  useLazyGetCategoryByIdQuery,
  useUpdateCategoryMutation,
  usePostAddCategoryMutation,
} from "../../services/main";
import { Loader, showError, showToast } from "../../constants";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { UploadMedia } from "../../utils/mediaUpload";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import useTranslation from "../../hooks/Translation";
import { useLanguageContext } from "../../context/Language";
import {
  arabicInputProps,
  withArabicFieldClass,
} from "../../utils/arabicField";
const AddCategories = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { language } = useLanguageContext() as any;
  const [category, setCategory] = useState<any>([]);
  const [getCategories, { isLoading }] = useLazyGetCategoriesQuery();
  const [addCategoryMutation] = usePostAddCategoryMutation();
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [getCategoryDetails] = useLazyGetCategoryByIdQuery();
  const [updateCategory] = useUpdateCategoryMutation();
  const [categoryById, setCategoryById] = useState<any>();
  const [categoryError, setCategoryError] = useState("");
  const translate = useTranslation();

  const getCategoryDetail = async (id: string | undefined) => {
    try {
      const res = await getCategoryDetails({ categoryId: id }).unwrap();
      if (res?.statusCode === 200) {
        setCategoryById(res?.data);
        setImage(res?.data?.image);
        setSelectedCategory(res?.data?.parent?._id);
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };
  const [isLoading2,setIsLoading2]=useState(false);
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
setIsLoading2(true)
    const res = await UploadMedia(file);
    if (res?.statusCode === 200) {
      setImage(res?.data);
    } else {
      showError(res?.message);
    }
    setIsLoading2(false)
  };

  const getCategory = async () => {
    try {
      const response = await getCategories({
        query: "",
        page: 1,
        type: 1,
        categoryId: "",
      }).unwrap();
      if (response?.statusCode === 200) {
        setCategory(response?.data?.category || []);
      } else {
        setCategory([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: categoryById?.name || "",
      title_ar: categoryById?.name_ar || "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required(translate?.error?.required || "")
        .max(15, translate?.error?.maxValidation15 || "")
        .min(2, translate?.error?.minValidation2 || ""),
      title_ar: Yup.string()
        .required(translate?.error?.required || "")
        .max(15, translate?.error?.maxValidation15 || "")
        .min(2, translate?.error?.minValidation2 || ""),
    }),
    onSubmit: async () => {
      // Validate category selection - Required field
      if (!selectedCategory || selectedCategory === "") {
        setCategoryError(translate?.error?.required || "");
        formik.setSubmitting(false);
        return;
      }
      setCategoryError("");

      formik.setSubmitting(true);

      const data = {
        name: formik?.values?.title,
        name_ar: formik?.values?.title_ar,
        image: image,
        parent: selectedCategory,
      };

      if (id && id !== "add") {
        try {
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await updateCategory({
            userId: id,
            encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            showToast(translate?.error?.subCatUpdate || "");
            navigate("/manage-categories");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          // Check if error is about parent field
          if (error?.data?.message?.toLowerCase().includes("parent")) {
            setCategoryError(
              error?.data?.message || translate?.main?.Pleaseselectcategory || "",
            );
          } else {
            showError(error?.data?.message || "");
          }
          console.log(error);
        } finally {
          formik.setSubmitting(false);
        }
      } else {
        try {
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await addCategoryMutation(encryptedBody).unwrap();
          if (response?.statusCode === 200) {
            showToast(translate?.error?.subCatAdd || "");
            formik.resetForm();
            navigate("/manage-categories");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          // Check if error is about parent field
          if (error?.data?.message?.toLowerCase().includes("parent")) {
            setCategoryError(
              error?.data?.message || translate?.main?.Pleaseselectcategory || "",
            );
          } else {
            showError(error?.data?.message || "");
          }
          console.log(error);
        } finally {
          formik.setSubmitting(false);
        }
      }
    },
  });

  const handleCategoryChange = (event: SelectChangeEvent) => {
    setSelectedCategory(event.target.value as string);
    setCategoryError(""); // Clear error when category is selected
  };

  useEffect(() => {
    if (id && id !== "add") {
      getCategoryDetail(id);
    }
  }, []);

  useEffect(() => {
    getCategory();
  }, []);

  return (
    <>
      <MainContainer>
      <Loader isLoad={isLoading2}/>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>{translate?.main?.addSubCat}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-categories");
              }}
            >
              {translate?.main?.Back}
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">{translate?.main?.Image}</Typography>
                    {image ? (
                      <div className="upload_image_preview category_icon_upload">
                        <CardMedia
                          component="img"
                          image={resolveMediaUrl(image)}
                          alt="photo"
                          sx={{
                            backgroundColor: "transparent",
                            background: "transparent",
                          }}
                        />
                        <CancelIcon
                          onClick={() => {
                            setImage("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => handleImageUpload(e)}
                          />
                          <Button
                            component="span"
                            className="upload_image_btn category_icon_upload"
                          >
                            <span className="category_icon_placeholder">
                              <CameraAltIcon />
                            </span>
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.main?.selectCat}
                    </Typography>
                    <FormControl sx={{ width: "100%" }} required error={!!categoryError}>
                      <Select
                        className="select_div"
                        fullWidth
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedCategory}
                        inputProps={{
                          "aria-label": "Without label",
                        }}
                        displayEmpty
                        onChange={handleCategoryChange}
                        error={!!categoryError}
                        required
                      >
                        <MenuItem value="" disabled>
                          {translate?.dashboard?.Select}
                        </MenuItem>
                        {category?.length
                          ? category?.map((item: any) => (
                              <MenuItem key={item?._id} value={item?._id}>
                                {(language === 'ar' ? item?.name_ar || item?.name : item?.name) || ""}
                              </MenuItem>
                            ))
                          : null}
                      </Select>
                      {categoryError && (
                        <Typography className="err_msg" sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>
                          {categoryError}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.main?.subCatNameEn}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="title"
                      variant="outlined"
                      className="text_field"
                      fullWidth
                      placeholder={translate?.main?.subCatNameEn || ""}
                      inputProps={{ maxLength: 15 }}
                      onBlur={formik.handleBlur}
                      value={formik.values.title}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={formik.touched.title && formik.errors.title}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {translate?.main?.subCatNameAr}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="title_ar"
                      variant="outlined"
                      className={withArabicFieldClass("text_field")}
                      inputProps={{ ...arabicInputProps, maxLength: 15 }}
                      fullWidth
                      placeholder={translate?.main?.subCatNameAr || ""}
                      onBlur={formik.handleBlur}
                      value={formik.values.title_ar}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.title_ar && formik.errors.title_ar
                      }
                    />
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {translate?.main?.Save}
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default AddCategories;
